import { Box } from '@mui/material'
import IconHeart from '../assets/icons/IconHeart.png'

const About = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '50vh'
            }}
        >
            <h3>With {<img src={IconHeart} alt="Hjärta" style={{ width: '24px', height: '24px' }} />} from Funki</h3>
            <h3>v. 3.1.2</h3>
        </Box>
    )
}

export default About
